function resolveClassName(className, state) {
  return typeof className === "function" ? className(state) : className;
}
export {
  resolveClassName
};
//# sourceMappingURL=resolveClassName.js.map
